import React, { useEffect, useState } from "react";
import {
  surveyResultPreview,
  sendQuote,
  sendResult,
} from "../../../api/services/services";
import backArrow from "../../../imgs/BackArrow.svg";
import MainTemplate from "../../templates/MainTemplate";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { Button, Snackbar, Box, Grid } from "@mui/material";
import PremiumPageLayout from "../../templates/PremiumPageLayout";
import PremiumCard from "../../molecules/PremiumCard";
import SectionHeader from "../../molecules/SectionHeader";
import DescriptionIcon from "@mui/icons-material/Description";
import ShareIcon from "@mui/icons-material/Share";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AssessmentIcon from "@mui/icons-material/Assessment";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import Typography from "@mui/material/Typography";
import { Row, Col } from "react-bootstrap";
import MuiAlert from "@mui/material/Alert";
import PaymentPlanForm from "../../molecules/PaymentPlanForm";
import SeaPaymentPlanForm from "../../molecules/SeaPaymentPlanForm";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

import { Bucket } from "../../../api/config/apiConfig";
import PrintComponent from "../PrintComponent";
import SurveyPreviewDownload from "./download";
import moment from "moment";
import gifLoading from "../../../imgs/giphy.gif";
import LazyImage from "../LazyLoadImage";

const SurveyPreviewPage = () => {
  const id = window.location.pathname.split("/")[2];
  const [surveyData, setSurveyData] = useState(null);
  const navigate = useNavigate();

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  var totalWeight = 0;
  var totalCbm = 0;
  var totalItems = 0;

  const [selectedMode, setSelectedMode] = useState("air");

  const handleModeChange = (event) => {
    setSelectedMode(event.target.value);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const printAction = () => {
    setTimeout(() => {
      window.print();
    }, 500);
  };

  const getSurvey = () => {
    surveyResultPreview(id)
      .then((response) => {
        setSurveyData(response?.data?.data);
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
        console.error("Error fetching survey:", error?.response?.data);
      });
  };

  const sendQuotation = (formData) => {
    let body = {};

    if (selectedMode == "road" || selectedMode == "air") {
      body = {
        surveyResultId: surveyData?.surveyDetail?.surveyResult?.uuid,
        shipmentMethod: selectedMode,
        pricing: {
          doorToDoor: parseFloat(formData?.doorToDoor),
          doorToPort: parseFloat(formData?.doorToPort),
          portToDoor: parseFloat(formData?.portToDoor),
          transportService: parseFloat(formData?.transt),
          vehicleService: parseFloat(formData?.impExp),
          packingService: parseFloat(formData?.ship),
        },
      };
    } else {
      body = {
        surveyResultId: surveyData?.surveyDetail?.surveyResult?.uuid,
        shipmentMethod: selectedMode,
        seaShipmentPricing: [
          {
            containerSize: "twentyft",
            pricing: {
              doorToDoor: parseFloat(formData?.doorToDoor),
              doorToPort: parseFloat(formData?.doorToPort),
              portToDoor: parseFloat(formData?.portToDoor),
              transportService: parseFloat(formData?.transt),
              vehicleService: parseFloat(formData?.impExp),
              packingService: parseFloat(formData?.ship),
            },
          },
          {
            containerSize: "fortyft",
            pricing: {
              doorToDoor: parseFloat(formData?.doorToDoor1),
              doorToPort: parseFloat(formData?.doorToPort1),
              portToDoor: parseFloat(formData?.portToDoor1),
              transportService: parseFloat(formData?.transt1),
              vehicleService: parseFloat(formData?.impExp1),
              packingService: parseFloat(formData?.ship1),
            },
          },
        ],
      };
    }

    if (selectedMode != "") {
      sendQuote(body)
        .then(() => {
          setSnackbarMessage("Quotation has been submitted successfully!");
          setOpenSnackbar(true);
          setTimeout(() => {
            navigate("/");
          }, 2000);
        })
        .catch((error) => {
          if (error?.response?.data?.statusCode == 401) {
            localStorage.clear();
            window.location.pathname = "/login";
          }
          setSnackbarMessage(error?.response?.data?.message || "Error sending quote");
          setOpenSnackbar(true);
        });
    } else {
      setSnackbarMessage("Please Select Shipment Mode!");
      setOpenSnackbar(true);
    }
  };

  useEffect(() => {
    getSurvey();
  }, []);

  const convertDate = (unixTimestamp) => {
    const date = new Date(unixTimestamp * 1000);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    const ordinalSuffix = getOrdinalSuffix(day);
    return `${day}${ordinalSuffix} ${month}, ${year}`;
  };

  const [isSharing, setIsSharing] = useState(false);

  const shareWithClient = () => {
    setIsSharing(true);
    const body = {
      surveyResultId: surveyData?.surveyDetail?.surveyResult?.uuid,
    };
    sendResult(body)
      .then(() => {
        setSnackbarMessage("Survey has been shared with the client successfully!");
        setOpenSnackbar(true);
        setIsSharing(false);
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
        setSnackbarMessage(error?.response?.data?.message || "Error sharing result");
        setOpenSnackbar(true);
        setIsSharing(false);
      });
  };

  const pageActions = (
    <>
      <Button
        variant="outlined"
        startIcon={<ShareIcon />}
        onClick={shareWithClient}
        disabled={isSharing}
         sx={{ 
          textTransform: "none", 
          borderRadius: "var(--radius-md)", 
          padding: "10px 24px",
          fontWeight: 700,
          border: "1px solid var(--glass-border)",
          color: "var(--text-main)",
          '&:hover': { background: 'var(--bg-color)', borderColor: 'var(--primary-color)' }
        }}
      >
        Share with Client
      </Button>
      <Button
        variant="contained"
        startIcon={<DescriptionIcon />}
        onClick={() => {
          if (window.innerWidth <= 768) {
      if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") {
        setSnackbarMessage("For a good experience, please use a desktop screen");
        setOpenSnackbar(true);
      } else {
        alert("For a good experience, please use a desktop screen");
      }
      return;
    }
            var tempTitle = document.title;
          document.title = `Survey Preview-${surveyData?.surveyDetail?.name}-${moment(new Date()).format("DD.MM.YYYY")}`;
          printAction();
          document.title = tempTitle;
        }}
        disabled={isSharing}
         sx={{ 
          textTransform: "none", 
          borderRadius: "var(--radius-md)", 
          padding: "10px 24px",
          fontWeight: 700,
          backgroundColor: "var(--text-main)",
           boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
           '&:hover': { backgroundColor: '#000' }
        }}
      >
        Save as PDF
      </Button>
    </>
  );

  return (
    <>
      <PremiumPageLayout 
        title="Survey Preview" 
        actions={pageActions}
        onBack={() => navigate(-1)}
      >
        <div className="no-print">
          {surveyData && (
            <>
              <SectionHeader title="Customer Information" icon={<VisibilityIcon />} />
              <PremiumCard sx={{ mb: 4 }}>
                <Row className="mb-4">
                  <Col md={12} className="text-start">
                    <Typography variant="h5" fontWeight="bold">
                      {surveyData?.surveyDetail?.name}
                    </Typography>
                  </Col>
                </Row>
                <Row>
                  <Col sm={6} md={3} className="mb-4">
                    <Box display="flex" alignItems="flex-start">
                      <Box sx={{ bgcolor: "#e3f2fd", p: 1, borderRadius: "8px", mr: 2, display: "flex", alignItems: "center", justifyContent: "center" }}>
                         <EmailIcon sx={{ color: "#1976d2" }} />
                      </Box>
                      <Box>
                         <Typography variant="subtitle2" fontWeight="bold" color="text.secondary">Email</Typography>
                         <Typography variant="body1" fontWeight="500" sx={{ wordBreak: 'break-word' }}>{surveyData?.surveyDetail?.email}</Typography>
                      </Box>
                    </Box>
                  </Col>
                  
                  <Col sm={6} md={3} className="mb-4">
                    <Box display="flex" alignItems="flex-start">
                      <Box sx={{ bgcolor: "#e3f2fd", p: 1, borderRadius: "8px", mr: 2, display: "flex", alignItems: "center", justifyContent: "center" }}>
                         <PhoneIcon sx={{ color: "#1976d2" }} />
                      </Box>
                      <Box>
                         <Typography variant="subtitle2" fontWeight="bold" color="text.secondary">Phone No.</Typography>
                         <Typography variant="body1" fontWeight="500" sx={{ wordBreak: 'break-word' }}>{surveyData?.surveyDetail?.loadPlacePhone}</Typography>
                      </Box>
                    </Box>
                  </Col>

                  <Col sm={6} md={3} className="mb-4">
                    <Box display="flex" alignItems="flex-start">
                      <Box sx={{ bgcolor: "#e3f2fd", p: 1, borderRadius: "8px", mr: 2, display: "flex", alignItems: "center", justifyContent: "center" }}>
                         <LocationOnIcon sx={{ color: "#1976d2" }} />
                      </Box>
                      <Box>
                         <Typography variant="subtitle2" fontWeight="bold" color="text.secondary">Origin Address</Typography>
                         <Typography variant="body1" fontWeight="500" sx={{ wordBreak: 'break-word' }}>
                           {surveyData?.surveyDetail?.loadPlaceStAddress}, {surveyData?.surveyDetail?.loadPlaceCity}, {surveyData?.surveyDetail?.loadPlaceCountry}
                         </Typography>
                      </Box>
                    </Box>
                  </Col>

                  <Col sm={6} md={3} className="mb-4">
                    <Box display="flex" alignItems="flex-start">
                      <Box sx={{ bgcolor: "#e3f2fd", p: 1, borderRadius: "8px", mr: 2, display: "flex", alignItems: "center", justifyContent: "center" }}>
                         <LocationOnIcon sx={{ color: "#1976d2" }} />
                      </Box>
                      <Box>
                         <Typography variant="subtitle2" fontWeight="bold" color="text.secondary">Destination Address</Typography>
                         <Typography variant="body1" fontWeight="500" sx={{ wordBreak: 'break-word' }}>
                           {surveyData?.surveyDetail?.unloadPlaceStAddress}, {surveyData?.surveyDetail?.unloadPlaceCity}, {surveyData?.surveyDetail?.unloadPlaceCountry}
                         </Typography>
                      </Box>
                    </Box>
                  </Col>

                  <Col sm={6} md={3} className="mb-4">
                    <Box display="flex" alignItems="flex-start">
                      <Box sx={{ bgcolor: "#e3f2fd", p: 1, borderRadius: "8px", mr: 2, display: "flex", alignItems: "center", justifyContent: "center" }}>
                         <EventAvailableIcon sx={{ color: "#1976d2" }} />
                      </Box>
                      <Box>
                         <Typography variant="subtitle2" fontWeight="bold" color="text.secondary">Removal Date</Typography>
                         <Typography variant="body1" fontWeight="500" sx={{ wordBreak: 'break-word' }}>
                           {surveyData?.surveyDetail?.loadDate ? formatDate(convertDate(surveyData?.surveyDetail?.loadDate)) : "-"}
                         </Typography>
                      </Box>
                    </Box>
                  </Col>
                  
                  <Col sm={6} md={3} className="mb-4">
                    <Box display="flex" alignItems="flex-start">
                      <Box sx={{ bgcolor: "#e3f2fd", p: 1, borderRadius: "8px", mr: 2, display: "flex", alignItems: "center", justifyContent: "center" }}>
                         <CalendarTodayIcon sx={{ color: "#1976d2" }} />
                      </Box>
                      <Box>
                         <Typography variant="subtitle2" fontWeight="bold" color="text.secondary">Survey Date</Typography>
                         <Typography variant="body1" fontWeight="500" sx={{ wordBreak: 'break-word' }}>
                           {surveyData?.surveyDetail?.surveyDate ? formatDate(convertDate(surveyData?.surveyDetail?.surveyDate)) : "-"}
                         </Typography>
                      </Box>
                    </Box>
                  </Col>
                </Row>
              </PremiumCard>

              <SectionHeader title="Survey Description" icon={<DescriptionIcon />} />
              <PremiumCard sx={{ mb: 4 }}>
                  <Typography variant="body1" sx={{ whiteSpace: 'pre-line', color: 'text.secondary' }}>
                      {surveyData?.surveyDetail?.description || "No description provided."}
                  </Typography>
              </PremiumCard>

              <SectionHeader title="Survey Overview" icon={<AssessmentIcon />} />
              <PremiumCard sx={{ mb: 4 }}>
                  <Grid container spacing={2}>
                      <Grid item xs={3}><Typography variant="subtitle2" fontWeight="bold">Room</Typography></Grid>
                      <Grid item xs={3}><Typography variant="subtitle2" fontWeight="bold">Weight</Typography></Grid>
                      <Grid item xs={3}><Typography variant="subtitle2" fontWeight="bold">CBM</Typography></Grid>
                      <Grid item xs={3}><Typography variant="subtitle2" fontWeight="bold">Items</Typography></Grid>
                  </Grid>
                  {surveyData?.roomWiseCalculation?.length > 0 &&
                   surveyData?.roomWiseCalculation?.map((cat, index) => {
                      totalWeight += cat?.totalWeightKg || 0;
                      totalCbm += cat?.totalCbm || 0;
                      totalItems += cat?.totalItems || 0;
                      return (
                          <Grid container spacing={2} key={index} sx={{ borderBottom: '1px solid #f0f0f0', py: 1 }}>
                              <Grid item xs={3}><Typography variant="body2">{cat?.roomName || "-"}</Typography></Grid>
                              <Grid item xs={3}><Typography variant="body2">{cat?.totalWeightKg ? `${cat?.totalWeightKg.toFixed(4)} kg` : "0 kg"}</Typography></Grid>
                              <Grid item xs={3}><Typography variant="body2">{cat?.totalCbm ? `${cat?.totalCbm.toFixed(4)} m³` : "0 m³"}</Typography></Grid>
                              <Grid item xs={3}><Typography variant="body2">{cat?.totalItems || "-"}</Typography></Grid>
                          </Grid>
                      )
                  })}
                  <Box sx={{ my: 1 }} />
                  <Grid container spacing={2} sx={{ bgcolor: '#f8fafc', p: 2, borderRadius: 1 }}>
                     <Grid item xs={3}><Typography variant="subtitle1" fontWeight="bold">Total</Typography></Grid>
                     <Grid item xs={3}><Typography variant="subtitle1" fontWeight="bold">{totalWeight.toFixed(4)} kg</Typography></Grid>
                     <Grid item xs={3}><Typography variant="subtitle1" fontWeight="bold">{totalCbm.toFixed(4)} m³</Typography></Grid>
                     <Grid item xs={3}><Typography variant="subtitle1" fontWeight="bold">{totalItems}</Typography></Grid>
                  </Grid>
              </PremiumCard>

              {surveyData?.surveyDetail?.surveyResult?.surveyRooms?.length > 0 && (
                <>
                  <SectionHeader title="Rooms Detail" icon={<MeetingRoomIcon />} />
                  {surveyData?.surveyDetail?.surveyResult?.surveyRooms?.map((sr, index) => {
                    if (!sr) return null;
                    return (
                    <PremiumCard key={index} sx={{ mb: 4 }}>
                      <Typography variant="h6" fontWeight="bold" sx={{ mb: 3 }}>{index+1}. {sr.name}</Typography>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={5}>
                           <div className="d-flex flex-wrap gap-2">
                             {sr?.images?.map((img, i) => (
                               <div key={i} style={{ borderRadius: '8px', overflow: 'hidden', border: '1px solid #eee' }}>
                                 <LazyImage src={Bucket + img} placeholderSrc={gifLoading} height={150} width={120} />
                               </div>
                             ))}
                           </div>
                        </Grid>
                        <Grid item xs={12} md={7}>
                          {/* Items Grid */}
                          {['movable', 'nonmovable', 'packing'].map(type => {
                             const items = type === 'packing' ? sr.packingMaterial : sr.roomItems?.filter(i => i.type === type);
                             if (!items || items.length === 0) return null;
                             return (
                               <Box key={type} sx={{ mb: 2 }}>
                                 <Typography variant="subtitle2" color="primary" fontWeight="bold">{type === 'movable' ? 'Moving' : type === 'nonmovable' ? 'Not Moving' : 'Packing Material'}</Typography>
                                 {items.map((item, i) => (
                                   <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5, borderBottom: '1px dashed #eee' }}>
                                     <Typography variant="body2">{item.name}</Typography>
                                     <Typography variant="body2" fontWeight="bold">{item.quantity}x</Typography>
                                   </Box>
                                 ))}
                               </Box>
                             )
                          })}
                          {sr.remarks && (
                            <Box sx={{ mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                              <Typography variant="caption" fontWeight="bold" color="text.secondary">REMARKS</Typography>
                              <Typography variant="body2">{sr.remarks}</Typography>
                            </Box>
                          )}
                        </Grid>
                      </Grid>
                    </PremiumCard>
                  )})}
                </>
              )}

              {/* Quotation Section */}
              {surveyData?.surveyDetail?.surveyResult?.status != "quotesent" ? (
                <>
                  <SectionHeader title="Shipment Mode Selection" icon={<AssessmentIcon />} />
                  <PremiumCard sx={{ mb: 4 }}>
                    <RadioGroup value={selectedMode} onChange={handleModeChange} row>
                      <FormControlLabel value="sea" control={<Radio />} label="By Sea" />
                      <FormControlLabel value="air" control={<Radio />} label="By Air" />
                      <FormControlLabel value="road" control={<Radio />} label="By Road" />
                    </RadioGroup>
                  </PremiumCard>
                  
                  <SectionHeader title="Shipment Payment Plans" icon={<DescriptionIcon />} />
                  {selectedMode == "road" || selectedMode == "air" ? (
                    <PaymentPlanForm onSubmit={sendQuotation} />
                  ) : (
                    <SeaPaymentPlanForm onSubmit={sendQuotation} />
                  )}
                </>
              ) : (
                <>
                  <SectionHeader title="Shipment Mode" icon={<AssessmentIcon />} />
                  <PremiumCard sx={{ mb: 4 }}>
                    <Typography variant="body1" fontWeight="bold" sx={{ color: 'primary.main' }}>
                      By {surveyData?.surveyDetail?.surveyResult?.surveyQuote?.shipmentMethod}
                    </Typography>
                  </PremiumCard>

                  <SectionHeader title="Shipment Payment Details" icon={<DescriptionIcon />} />
                  <PremiumCard sx={{ mb: 4 }}>
                    {surveyData?.surveyDetail?.surveyResult?.surveyQuote?.shipmentMethod == "air" ||
                     surveyData?.surveyDetail?.surveyResult?.surveyQuote?.shipmentMethod == "road" ? (
                      <Grid container spacing={3}>
                        {['doorToDoor', 'doorToPort', 'portToDoor', 'transportService', 'vehicleService', 'packingService'].map(key => (
                          <Grid item xs={6} md={4} key={key}>
                            <Typography variant="subtitle2" color="text.secondary" sx={{ textTransform: 'capitalize' }}>{key.replace(/([A-Z])/g, ' $1')}</Typography>
                            <Typography variant="body1" fontWeight="bold">{surveyData?.surveyDetail?.surveyResult?.surveyQuote?.pricing?.[key] || 0}</Typography>
                          </Grid>
                        ))}
                      </Grid>
                    ) : (
                      <Box>
                        {surveyData?.surveyDetail?.surveyResult?.surveyQuote?.seaShipmentPricing?.map((pr, idx) => (
                          <Box key={idx} sx={{ mb: 3, pb: 3, borderBottom: idx === 0 ? '1px solid #eee' : 'none' }}>
                            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>{idx + 1}. {pr?.containerSize === "twentyft" ? "Twenty Feet" : "Forty Feet"} Container</Typography>
                            <Grid container spacing={3}>
                              {['doorToDoor', 'doorToPort', 'portToDoor', 'transportService', 'vehicleService', 'packingService'].map(key => (
                                <Grid item xs={6} md={4} key={key}>
                                  <Typography variant="subtitle2" color="text.secondary" sx={{ textTransform: 'capitalize' }}>{key.replace(/([A-Z])/g, ' $1')}</Typography>
                                  <Typography variant="body1" fontWeight="bold">{pr?.pricing?.[key] || 0}</Typography>
                                </Grid>
                              ))}
                            </Grid>
                          </Box>
                        ))}
                      </Box>
                    )}
                  </PremiumCard>
                </>
              )}
            </>
          )}
        </div>
      </PremiumPageLayout>

      <PrintComponent>
        <SurveyPreviewDownload id="content-id" surveyData={surveyData} />
      </PrintComponent>

      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <MuiAlert elevation={6} variant="filled" severity={snackbarMessage?.includes("successful") ? "success" : "error"} onClose={handleCloseSnackbar}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};
export default SurveyPreviewPage;
